/**
 * Wyświetlanie wersji w konsoli dla celów dev
 */
export function logVersion() {
    if (typeof process !== 'undefined' && process.env && process.env.MODE === 'development') {
        const version = process.env.VERSION || '1.0.0';
        const year = process.env.YEAR || new Date().getFullYear().toString();
        console.log(`%cARTUR-TOMASZEWSKI.PL`, 'color: #00ffff; font-size: 16px; font-weight: bold;');
        console.log(`%cv${version} © ${year} [DEV]`, 'color: #ff00ff; font-size: 12px;');
    }
}

